import {Component, Input, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import { Notification } from './notification.model';


@Component({
    selector: 'frms-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
    ,changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {

    @Input()notification:Notification;
    @Input() active: boolean;

    @Output() onNewsHide: EventEmitter<any> = new EventEmitter();

    hideNews(event: Event) {
        this.onNewsHide.emit();
        event.preventDefault();
    }
    
}